import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados por equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await api.get(
      `/app/covid19/infantil/${cod_ibge}/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os dados por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorMicroarea(cod_ibge, nu_ine, microarea) {
  try {
    const { data } = await api.get(
      `/app/covid19/infantil/${cod_ibge}/equipe/${nu_ine}/micro-area/${microarea}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function formatarCadastrosComDoses(cadastros) {
  const data = cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)
    const vacinasAplicadas = JSON.parse(item.vacinas_aplicadas)

    // PFIZER COMIRNATY PEDIÁTRICA
    const coresPfizerCominartyPediatrica = createArrayDoses(3, [
      '1ª DOSE',
      '2ª DOSE',
      '3ª DOSE',
    ])
    const primeiraDosePfizerCominartyPediatrica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '102',
      '1'
    )
    const segundaDosePfizerCominartyPediatrica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '102',
      '2'
    )
    const terceiraDosePfizerCominartyPediatrica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '102',
      '3'
    )

    if (primeiraDosePfizerCominartyPediatrica.tipo == 'aplicada') {
      coresPfizerCominartyPediatrica[0].cor = 'green'
      coresPfizerCominartyPediatrica[0].dt_aplicacao_br =
        primeiraDosePfizerCominartyPediatrica.dt_aplicacao_br
      coresPfizerCominartyPediatrica[0].dose_anterior =
        primeiraDosePfizerCominartyPediatrica.dose_anterior
    } else {
      coresPfizerCominartyPediatrica[0].cor =
        primeiraDosePfizerCominartyPediatrica.cor
      coresPfizerCominartyPediatrica[0].dt_aplicacao_br = ''
      coresPfizerCominartyPediatrica[0].sg_d =
        primeiraDosePfizerCominartyPediatrica.sg_d
      coresPfizerCominartyPediatrica[0].sg_im =
        primeiraDosePfizerCominartyPediatrica.sg_im
    }

    if (segundaDosePfizerCominartyPediatrica.tipo == 'aplicada') {
      coresPfizerCominartyPediatrica[1].cor = 'green'
      coresPfizerCominartyPediatrica[1].dt_aplicacao_br =
        segundaDosePfizerCominartyPediatrica.dt_aplicacao_br
      coresPfizerCominartyPediatrica[1].dose_anterior =
        segundaDosePfizerCominartyPediatrica.dose_anterior
    } else {
      coresPfizerCominartyPediatrica[1].cor =
        segundaDosePfizerCominartyPediatrica.cor
      coresPfizerCominartyPediatrica[1].dt_aplicacao_br = ''
      coresPfizerCominartyPediatrica[1].sg_d =
        segundaDosePfizerCominartyPediatrica.sg_d
      coresPfizerCominartyPediatrica[1].sg_im =
        segundaDosePfizerCominartyPediatrica.sg_im
    }

    if (terceiraDosePfizerCominartyPediatrica.tipo == 'aplicada') {
      coresPfizerCominartyPediatrica[2].cor = 'green'
      coresPfizerCominartyPediatrica[2].dt_aplicacao_br =
        terceiraDosePfizerCominartyPediatrica.dt_aplicacao_br
      coresPfizerCominartyPediatrica[2].dose_anterior =
        terceiraDosePfizerCominartyPediatrica.dose_anterior
    } else {
      coresPfizerCominartyPediatrica[2].cor = 'white'
      coresPfizerCominartyPediatrica[2].dt_aplicacao_br = ''
      coresPfizerCominartyPediatrica[2].sg_d =
        terceiraDosePfizerCominartyPediatrica.sg_d
      coresPfizerCominartyPediatrica[2].sg_im =
        terceiraDosePfizerCominartyPediatrica.sg_im
    }

    // Sinovac / Butantan - Coronavac
    const coresSinovacButantanCoronavac = createArrayDoses(3, [
      '1ª DOSE',
      '2ª DOSE',
      '3ª DOSE',
    ])
    const primeiraDoseSinovacButantanCoronavac = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '86',
      '1'
    )
    const segundaDoseSinovacButantanCoronavac = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '86',
      '2'
    )
    const terceiraDoseSinovacButantanCoronavac = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '86',
      '3'
    )

    if (primeiraDoseSinovacButantanCoronavac.tipo == 'aplicada') {
      coresSinovacButantanCoronavac[0].cor = 'green'
      coresSinovacButantanCoronavac[0].dt_aplicacao_br =
        primeiraDoseSinovacButantanCoronavac.dt_aplicacao_br
      coresSinovacButantanCoronavac[0].dose_anterior =
        primeiraDoseSinovacButantanCoronavac.dose_anterior
    } else {
      coresSinovacButantanCoronavac[0].cor =
        primeiraDoseSinovacButantanCoronavac.cor
      coresSinovacButantanCoronavac[0].dt_aplicacao_br = ''
      coresSinovacButantanCoronavac[0].sg_d =
        primeiraDoseSinovacButantanCoronavac.sg_d
      coresSinovacButantanCoronavac[0].sg_im =
        primeiraDoseSinovacButantanCoronavac.sg_im
    }

    if (segundaDoseSinovacButantanCoronavac.tipo == 'aplicada') {
      coresSinovacButantanCoronavac[1].cor = 'green'
      coresSinovacButantanCoronavac[1].dt_aplicacao_br =
        segundaDoseSinovacButantanCoronavac.dt_aplicacao_br
      coresSinovacButantanCoronavac[1].dose_anterior =
        segundaDoseSinovacButantanCoronavac.dose_anterior
    } else {
      coresSinovacButantanCoronavac[1].cor =
        segundaDoseSinovacButantanCoronavac.cor
      coresSinovacButantanCoronavac[1].dt_aplicacao_br = ''
      coresSinovacButantanCoronavac[1].sg_d =
        segundaDoseSinovacButantanCoronavac.sg_d
      coresSinovacButantanCoronavac[1].sg_im =
        segundaDoseSinovacButantanCoronavac.sg_im
    }

    if (terceiraDoseSinovacButantanCoronavac.tipo == 'aplicada') {
      coresSinovacButantanCoronavac[2].cor = 'green'
      coresSinovacButantanCoronavac[2].dt_aplicacao_br =
        terceiraDoseSinovacButantanCoronavac.dt_aplicacao_br
      coresSinovacButantanCoronavac[2].dose_anterior =
        terceiraDoseSinovacButantanCoronavac.dose_anterior
    } else {
      coresSinovacButantanCoronavac[2].cor = 'white'
      coresSinovacButantanCoronavac[2].dt_aplicacao_br = ''
      coresSinovacButantanCoronavac[2].sg_d =
        terceiraDoseSinovacButantanCoronavac.sg_d
      coresSinovacButantanCoronavac[2].sg_im =
        terceiraDoseSinovacButantanCoronavac.sg_im
    }

    return {
      id: index,
      ...item,
      coresPfizerCominartyPediatrica,
      coresSinovacButantanCoronavac,
    }
  })

  return data
}

function createArrayDoses(quantElements, labels) {
  let data = []
  for (let index = 0; index < quantElements; index++) {
    data.push({
      dose: `${labels[index]}`,
      cor: 'white',
      dt_aplicacao_br: '',
      dose_anterior: '',
      sg_d: '',
      sg_im: '',
    })
  }
  return data
}

function encontrarDose(vacinasPendentes, vacinasAplicadas, id_im, id_d) {
  if (vacinasPendentes != null) {
    const dosePendente = vacinasPendentes.find(
      (el) => el.id_im == Number(id_im) && el.id_d == Number(id_d)
    )
    if (dosePendente !== undefined) {
      return {
        tipo: 'pendente',
        cor: 'red',
        dt_aplicacao_br: '',
        sg_d: dosePendente.sg_d,
        sg_im: dosePendente.sg_im,
      }
    }
  }
  if (vacinasAplicadas != null) {
    const doseAplicada = vacinasAplicadas.find(
      (el) => el.id_imuno == id_im && el.id_dose_imuno == id_d
    )
    if (doseAplicada !== undefined) {
      return {
        tipo: 'aplicada',
        dt_aplicacao: doseAplicada.dt_aplicacao,
        dt_aplicacao_br: doseAplicada.dt_aplicacao_br,
        dose_anterior: doseAplicada.dose_anterior,
      }
    }
  }
  return {
    tipo: 'pendente',
    cor: 'white',
    dt_aplicacao_br: '',
    sg_d: '',
    sg_im: '',
  }
}

export function generatePdf(cadastros, selectEquipe, microarea) {
  const titlePdf = 'COVID-19 Infantil'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, selectEquipe.no_equipe)
  const descriptionPdf = 'Crianças entre 6 meses e 4 anos'
  const headersPdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'DOSES FIZER',
    'DOSES Sinovac',
    'DOCUMENTO',
  ]

  const doses = formatarCadastrosComDoses(cadastros)
  const dataPdf = doses.map((item, index) => {
    const documentos = []
    if (cadastros[index]?.nu_cpf)
      documentos.push(`CPF ${cadastros[index].nu_cpf}`)
    if (cadastros[index]?.nu_cns)
      documentos.push(`CNS ${cadastros[index].nu_cns}`)

    return {
      no_cidadao: item.no_cidadao,
      dt_nascimento: utils.methods.formatDate(item.dt_nascimento),
      no_mae: item.no_mae,
      ma: item.micro_area,
      coresPfizerCominartyPediatrica: item.coresPfizerCominartyPediatrica
        .map((d) => `${d.dose} - ${d.dt_aplicacao_br}`)
        .join('\n'),
      coresSinovacButantanCoronavac: item.coresSinovacButantanCoronavac
        .map((d) => `${d.dose} - ${d.dt_aplicacao_br}`)
        .join('\n'),
      documento: documentos.join('\n'),
    }
  })

  const doc = new jsPDF(utils.methods.encryptionPdf())
  const table = utils.methods.createTablePdf(dataPdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          { label: 'Equipe', value: selectEquipe.no_equipe },
          { label: 'CNES', value: selectEquipe.nu_cnes },
          { label: 'INE', value: selectEquipe.nu_ine },
          { label: 'Microárea', value: microarea },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ row }) => {
          if (row.section === 'head') doc.setTextColor(0, 0, 0)
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}

export function printTableRow(item) {
  // vermelhos
  if (item.vacinas_pendentes !== null) {
    let vacinas = JSON.parse(item.vacinas_pendentes)
    let vacina = vacinas.find((el) => {
      return el.id_im == 102 || el.id_im == 86
    })
    if (vacina != undefined) {
      return 'red'
    }
  }

  // verdes
  if (item.vacinas_aplicadas !== null) {
    let vacinas = JSON.parse(item.vacinas_aplicadas)
    let vacina = vacinas.find((el) => {
      return el.id_imuno == 102 || el.id_imuno == 86
    })
    if (vacina != undefined) {
      return 'green'
    }
  }
}
